import { render, staticRenderFns } from "./EditServiceSidebarNotes.vue?vue&type=template&id=258ee680&scoped=true&"
import script from "./EditServiceSidebarNotes.vue?vue&type=script&lang=js&"
export * from "./EditServiceSidebarNotes.vue?vue&type=script&lang=js&"
import style0 from "./EditServiceSidebarNotes.vue?vue&type=style&index=0&id=258ee680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258ee680",
  null
  
)

export default component.exports